﻿"use strict";
//########################################
//# index.js KAV RP Erhebung online
//########################################
import $ from 'jquery';
window.$ = window.jQuery = $; // export for other scripts to use
// eslint-disable-next-line no-unused-vars
import config from 'devextreme/core/config';
import DevExpress from "devextreme/bundles/modules/core";
import ui from "devextreme/bundles/modules/ui";
DevExpress.ui = ui;
import {confirm, alert } from "devextreme/ui/dialog";
DevExpress.ui.dialog = {};
DevExpress.ui.dialog.confirm = confirm;
DevExpress.ui.dialog.alert = alert;
import notify from "devextreme/ui/notify"
DevExpress.ui.notify = notify;
import 'devextreme/integration/jquery';
import "devextreme/ui/popup";
import "devextreme/ui/form";
import "devextreme/ui/button";
import "devextreme/ui/drop_down_box";
import "devextreme/ui/data_grid";
import "devextreme/ui/select_box";
import "devextreme/ui/date_box";
import "devextreme/ui/text_area";
import "devextreme/ui/scroll_view";
import "devextreme/localization";

import { licenseKey } from './devextreme-license'; 
config({ licenseKey });   

import * as german from "./german.js";
import * as Login from './login.js';
import * as Survey from './survey.js';
import * as surveyHelper from './generated_erhebung_support.js';
import * as t from './tools.js';
window.t = t;

german.initTexts();


window.CONFIG = {
    serverApi: 'https://kav-rp-service.de/kav/api/v1/survey',      // wird beim build korrekt für das jew. Environment gesetzt
    clientBaseUrl: 'https://kav-rp-service.de/Erhebung',  // dito
    buildMode: 'production',      // auch
    authHeader: "kavrp-sessionid",
    surveyHelper: surveyHelper,
    home: "https://kav-rp.de",
    specialLogin: undefined
};

$(function () {
    const path = window.location.pathname.toLowerCase().replace('.html', '');
    window.CONFIG.customHeaders = {};

    if (path.endsWith('/neumitglied')) {
        window.CONFIG.specialLogin = "neu";
        document.title = "KAV RP Personalbestandserhebung online für Neumitglied";
        $("#common-head-title").text("Personalstandserhebung online - Neumitglied");
        Login.pageInit(continueAfterLogin);
        return;
    }

    if (path.endsWith('/') || path.endsWith('/index') || path.endsWith('/login')) {
        const url = new URL(window.CONFIG.serverApi + "/status");
        const request = {
            cache: false,
            url: url,
            contentType: 'application/json',
            method: 'GET',
            success: function (response) {
                if (response.activeState == 0) {
                    Login.pageInit(continueAfterLogin);
                } else {
                    t.showErrorInPage(response.statusText, "Hinweis");
                }
            },
            error: function (jqXHR) {
                t.showErrorInPage(jqXHR);
            }
        };
        $.ajax(request);
        
    //} else if (path.endsWith('/survey')) { // nicht bei der aktuellen einfachen Struktur
    //    //pageInitManagerAddActivity();
    }
});

function continueAfterLogin(loginResponse) {
    window.CONFIG.sessionId = loginResponse.sessionId;
    window.CONFIG.customHeaders[window.CONFIG.authHeader] = window.CONFIG.sessionId;
    Survey.pageInit(loginResponse);
}
